module.exports = __webpack_public_path__ + "img/member-pick.dd0f44ea.png";